module.exports = __webpack_public_path__ + "assets/img/9cb33b3833da4d36f21ada9f1dc75fb7.png";